import { PHONE_DISPLAY } from "@/config/site";

export const SITE = "BM Towing & Recovery";

export const DEFAULT_TITLE = `${SITE} — 24/7 Towing in Kirkland & Bellevue, WA | ${PHONE_DISPLAY}`;

export const DEFAULT_DESCRIPTION = `${SITE} — 24/7 tow truck, flatbed transport, roadside assistance, and recovery across Kirkland, Bellevue, Redmond, Bothell, Kenmore, Woodinville, and Issaquah, WA. Call ${PHONE_DISPLAY}.`;

export function buildFullTitle(title) {
  if (!title) return DEFAULT_TITLE;
  // Skip appending "| BM Towing & Recovery" when the page's own title already
  // contains the brand — prevents double-branding and keeps titles ≤ 60 chars.
  if (/BM\s*Towing/i.test(title)) return title;
  return `${title} | ${SITE}`;
}

export function buildDescription(description) {
  return description || DEFAULT_DESCRIPTION;
}

/**
 * Resolve a possibly-relative path to an absolute URL under siteUrl.
 * If input is already absolute (http/https), returns it unchanged.
 * If input is falsy, returns the site root.
 */
export function toAbsoluteUrl(pathOrUrl, siteUrl) {
  if (!pathOrUrl) return `${siteUrl}/`;
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  const suffix = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  return `${siteUrl}${suffix}`;
}

export function robotsContent(noindex) {
  return noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large";
}

/** Stable key for JSON-LD script blocks. */
export function jsonLdKey(obj) {
  const type = obj?.["@type"] || "ld";
  const id = obj?.name || obj?.url || JSON.stringify(obj).length;
  return `${type}-${id}`;
}

/** Normalize the jsonLd prop to an array (or empty). */
export function normalizeJsonLd(jsonLd) {
  if (!jsonLd) return [];
  return Array.isArray(jsonLd) ? jsonLd : [jsonLd];
}
